import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { BerthOutage } from "../utils/types/berthOutages";

export const fetchBerthOutages = async (locationId?: string) => {
  const params: Record<string, string> = {};
  if (locationId) params.location_id = locationId;
  const response = await axiosServices.get("/berth-outages", { params });
  return convertToCamelCase<BerthOutage[]>(response.data.data);
};

export const createBerthOutage = async (data: Partial<BerthOutage>) => {
  const requestData = convertToSnakeCase(data);
  const response = await axiosServices.post("/berth-outages", requestData);
  return convertToCamelCase<BerthOutage>(response.data.data);
};

export const updateBerthOutage = async (
  id: string,
  data: Partial<BerthOutage>
) => {
  const requestData = convertToSnakeCase(data);
  const response = await axiosServices.put(
    `/berth-outages/${id}`,
    requestData
  );
  return convertToCamelCase<BerthOutage>(response.data.data);
};

export const deleteBerthOutage = async (id: string) => {
  const response = await axiosServices.delete(`/berth-outages/${id}`);
  return { success: response?.data?.success, id };
};
